module.exports = __webpack_public_path__ + "static/media/tooltips_d_018.movie.bf9e9679.mp4";